// src/schedule/components/EventNoteEditor.jsx
import React from 'react';

/**
 * Komponent edytora notatek dla eventu
 */
export default function EventNoteEditor({ 
    open, 
    noteText, 
    onClose, 
    onSave, 
    onChange,
    onClear 
}) {
    if (!open) return null;

    return (
        <div 
            className="absolute top-9 right-2 w-60 rounded shadow-lg border
                        bg-white text-gray-900 border-gray-200
                        dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 p-2"
            style={{ zIndex: 2147483648 }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
        >
            <textarea
                value={noteText}
                onChange={(e) => onChange(e.target.value)}
                className="w-full h-24 rounded p-2 border outline-none
                           bg-white text-gray-900 border-gray-300
                           dark:bg-gray-900 dark:text-gray-100 dark:border-gray-700"
                placeholder="Notatka do wydarzenia..."
            />
            <div className="mt-2 flex justify-end gap-2">
                <button
                    className="px-3 py-1 text-sm rounded border
                               bg-white text-gray-900 border-gray-300 hover:bg-gray-50
                               dark:bg-gray-700 dark:text-gray-100 dark:border-gray-600 dark:hover:bg-gray-600"
                    onClick={onClose}
                >
                    Anuluj
                </button>
                <button
                    className="px-3 py-1 text-sm rounded
                               bg-blue-600 text-white hover:bg-blue-700"
                    onClick={onSave}
                >
                    Zapisz
                </button>
                {noteText && (
                    <button
                        className="px-3 py-1 text-sm rounded
                                   bg-red-600 text-white hover:bg-red-700"
                        onClick={onClear}
                    >
                        Wyczyść
                    </button>
                )}
            </div>
        </div>
    );
}

